import { LitElement, html, css } from "lit";
import { customElement } from "lit/decorators.js";
import { api } from "../api";
import hawaiiLogo from "../assets/hawaii-logo.png";

@customElement("login-view")
export class LoginView extends LitElement {
  static styles = css`
    :host {
      position: fixed;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 24px;
      background:
        radial-gradient(900px 420px at 50% -8%, var(--colors-background-bg-brand-50, #eff4ff), transparent 62%),
        var(--colors-background-bg-gray-50, #f9fafb);
      font-family: Geist, sans-serif;
    }

    bee-card {
      height: fit-content;
      width: 100%;
      max-width: 420px;
      margin: auto;
    }

    .wrapper {
      text-align: center;
      padding: 32px 28px;
    }

    .logo {
      display: block;
      width: 128px;
      height: auto;
      margin: 0 auto;
    }

    h1 {
      font-size: 22px;
      font-weight: 600;
      margin: 0 0 20px;
      color: var(--colors-foreground-fg-gray-900, #101828);
    }

    p {
      color: var(--colors-foreground-fg-gray-600, #5a6072);
      margin: 0 0 var(--spacing-24, 24px);
      font-size: 14px;
      line-height: 1.5;
    }

    .auth-options {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .auth-option {
      padding: 14px;
      border: 1px solid var(--colors-border-border-gray-200, #eaecf0);
      border-radius: 10px;
      background: var(--colors-background-bg-gray-50, #f9fafb);
    }

    .auth-option p {
      margin: 0 0 12px;
      font-size: 13px;
    }

    .sign-in-btn {
      display: inline-flex;
      width: 100%;
      box-sizing: border-box;
      align-items: center;
      justify-content: center;
      gap: 10px;
      padding: 11px 20px;
      background: #24292f;
      color: #fff;
      font-family: Geist, sans-serif;
      font-size: 14px;
      font-weight: 500;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      transition: background 0.15s ease;
    }

    .sign-in-btn:hover {
      background: #3a4249;
    }

    .sign-in-btn svg {
      width: 18px;
      height: 18px;
      flex-shrink: 0;
      fill: #fff;
    }

    .footnote {
      margin: 18px 0 0;
      font-size: 12px;
      color: var(--colors-foreground-fg-gray-500, #98a2b3);
    }
  `;

  private _login() {
    api.login();
  }

  render() {
    return html`
      <bee-card type="neutral" size="large">
        <div class="wrapper">
          <img class="logo" src=${hawaiiLogo} alt="HAWAII Delivery Platform" />
          <h1>Dashboard</h1>
          <div class="auth-options">
            <div class="auth-option">
              <p>Sign in with your GitHub account to view and manage products across environments.</p>
              <button class="sign-in-btn" @click=${this._login}>
                <svg viewBox="0 0 98 96" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M48.854 0C21.839 0 0 22 0 49.217c0 21.756 13.993 40.172 33.405 46.69 2.427.49 3.316-1.059 3.316-2.362 0-1.141-.08-5.052-.08-9.127-13.59 2.934-16.42-5.867-16.42-5.867-2.184-5.704-5.42-7.17-5.42-7.17-4.448-3.015.324-3.015.324-3.015 4.934.326 7.523 5.052 7.523 5.052 4.367 7.496 11.404 5.378 14.235 4.074.404-3.178 1.699-5.378 3.074-6.6-10.839-1.141-22.243-5.378-22.243-24.283 0-5.378 1.94-9.778 5.014-13.2-.485-1.222-2.184-6.275.486-13.038 0 0 4.125-1.304 13.426 5.052a46.97 46.97 0 0 1 12.214-1.63c4.125 0 8.33.571 12.213 1.63 9.302-6.356 13.427-5.052 13.427-5.052 2.67 6.763.97 11.816.485 13.038 3.155 3.422 5.015 7.822 5.015 13.2 0 18.905-11.404 23.06-22.324 24.283 1.78 1.548 3.316 4.481 3.316 9.126 0 6.6-.08 11.897-.08 13.526 0 1.304.89 2.853 3.316 2.364 19.412-6.52 33.405-24.935 33.405-46.691C97.707 22 75.788 0 48.854 0z"
                  />
                </svg>
                Sign in with GitHub
              </button>
            </div>
          </div>
          <p class="footnote">Access is restricted to members of the accuristech organization.</p>
        </div>
      </bee-card>
    `;
  }
}
